import Axios from 'axios';

export function normalizeTitanResident(resident) {
  let birthday;
  if (resident.dateNaissance?.length === 8) {
    birthday = new Date(
      resident.dateNaissance.substring(0, 4),
      resident.dateNaissance.substring(4, 6),
      resident.dateNaissance.substring(6, 8),
    );
  }

  return {
    Actif: resident.present ? "1" : "0",
    DateNaissance: birthday,
    Genre: resident.sexe === 1 ? "HOMME" : "FEMME", // 1: H, 2: F
    Nom: resident.nom,
    Prenom: resident.prenom,
    Fullname: `${resident.nom} ${resident.prenom}`,
    Uri: `TITAN://patient#${resident.id}`,
  };
}

export function normalizeTitanStaff(staff) {
  return {
    Actif: "1",
    Nom: staff.lastName,
    Prenom: staff.firstName,
    Uri: `TITAN://user#${staff.id}_${staff.sites?.find(site => site.default)?.id ?? 1}`,
  };
}

export function normalizeTitanSector(sector) {
  return {
    Actif: "1",
    Uri: `TITAN://unite#${sector.id}`,
    Libelle: sector.name,
  };
}

export function normalizeTitanPlace(place) {
  return {
    Actif: "1",
    Libelle: place.name,
    Uri: `TITAN://place#${place.id}`,
  };
}

export default class {
  constructor(login, password, token, baseURL, externalURI) {
    this.headers = {
      username: login,
      password,
      token,
      baseURL,
      externalURI,
    }
    this.api = Axios.create({
      baseURL: 'https://titan-proxy.anisen.fr/',
      headers: {
        ... this.headers,
        'accept': 'application/json;charset=UTF-8',
        'Content-Type': 'application/json'
      },
    });

    this.refreshToken = null;
  }

  async getJobs() {
    const { data } = await this.api.get('EstablishmentInfo/Jobs');
    return data?.data ?? [];
  }

  /**
   * Pour le mapping avec les services
   */
  async getSectors() {
    const { data } = await this.api.get('EstablishmentInfo/Secteurs');
    return data?.data ?? [];
  }

  async getPlaces() {
    const { data } = await this.api.get('EstablishmentInfo/Lieux');
    return data?.data ?? [];
  }

  async getResidents() {
    const { data } = await this.api.get('EstablishmentInfo/Residents');
    return data?.data ?? [];
  }

  async getStaffs() {
    const { data } = await this.api.get('EstablishmentInfo/Staffs');
    return data?.data ?? [];
  }

  /**
   * Endpoint créant et récupérant l'activité 'Anisen' pour Titan.
   */
  async createOrGetAnisenActivity() {
    const { data } = await this.api.post('EstablishmentInfo/Activities/Anisen');
    return data?.data ?? null;
  }

  async getNotations() {
    const { data } = await this.api.get('EstablishmentInfo/Notations');
    return data?.data ?? [];
  }

  async importCustomActivitiesFromLDS(esta_id, useProdConfig = false) {
    const { data } = await this.api.post('EstablishmentInfo/sync/Activities', {estaId: esta_id, useProdConfig});
    return data?.data ?? null;
  }
};
